import axiosConfig from "./axiosConfig";
import { RecentHealthEvent } from "./getHealthOverview";

export interface HealthEventsInRangeResponse {
  events: RecentHealthEvent[];
}

// Cross-site health events active at any point in [from, to]. Both bounds are
// ISO datetimes (UTC). Powers the /operational/health date-range picker; the
// heavy availability/PR overview comes from the separate POST /health/events LRO.
const getHealthEventsInRange = async (
  authToken: string,
  from: string,
  to: string
): Promise<HealthEventsInRangeResponse> => {
  const { data } = await axiosConfig.get("/health/events", {
    headers: { Authorization: `Bearer ${authToken}` },
    params: { from, to },
  });
  return data;
};

export default getHealthEventsInRange;
